// extracted by mini-css-extract-plugin
export default {"marquee-wrap":"ODOVOE","marquee":"F0fArt"};